import { parseCaption } from './util.parse-caption.js';
import { parsePm2Data } from './util.parse-pm2-data.js';

const parseDocumentLinkElement = (node) => {
  const href = node.getAttribute("file");
  return parseLink(node, {
    href,
    target: "_blank",
    attributes: {
      download: "true"
    }
  });
};
const parseInternalLinkElement = (node) => {
  const href = node.getAttribute("url");
  return parseLink(node, {
    href,
    target: void 0,
    attributes: {}
  });
};
const parseExternalLinkElement = (node) => {
  const href = node.getAttribute("url");
  return parseLink(node, {
    href,
    target: "_blank",
    attributes: {}
  });
};
function parseLink(node, props) {
  var _a, _b;
  const caption = parseCaption(node);
  const pm2 = parsePm2Data(node, caption);
  const label = ((_a = caption.title) == null ? void 0 : _a.value) ?? ((_b = caption.description) == null ? void 0 : _b.value) ?? "\xC5bn link";
  const children = [
    {
      nodeType: "text",
      value: label
    }
  ];
  if (!pm2) {
    return null;
  }
  return {
    nodeType: "link",
    pm2,
    meta: {
      target: props.target
    },
    href: props.href ?? void 0,
    attributes: props.attributes,
    children
  };
}
const linkNodeParsers = {
  document: parseDocumentLinkElement,
  internalLink: parseInternalLinkElement,
  externalLink: parseExternalLinkElement
};

export { linkNodeParsers };
//# sourceMappingURL=common.links.js.map
